<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:showItem="{ row }">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              缸批号：
              {{ row.batchNo }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              颜色等级：
              {{ row.v_colorGrade }}
            </span>
          </el-col>

          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              实测门幅(CM)：
              {{ row.measuredWidth }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              实测克重(gsm)：
              {{ row.actualGSM }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              检验米数(米)：
              {{ row.inspectQuantity }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              实测米数(米)：
              {{ row.actualQuantity }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              合格米数(米)：
              {{ row.qualifiedQuantity }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              不良米数(米)：
              {{ row.defectiveQuantity }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              疵点总计：
              {{ row.defectTotalCount }}
            </span>
          </el-col>

          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              短码数量(米)：
              {{ row.shortQuantity }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              利用率：
              {{ row.utilizationRate }}%
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              短码率：
              {{ row.shortRate }}%
            </span>
          </el-col>
          <el-col
            :xs="{ span: 12 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              判定结果：
              <span
                :style="{
                  color:
                    row.finalResult === 'Y' ? ' #28A745' : ' #DC3545',
                }"
                >{{ row.v_finalResult }}</span
              >
            </span>
          </el-col>
          <el-col
            class="mt-2"
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <div class="d-flex">
              <div style="font-weight: bold;min-width: 65px;">
                重大问题：
              </div>
              <div v-if="row.requestList.length">
                <div v-for="(item, index) in row.requestList" :key="index">
                  <span>{{ item }}</span>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </div>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <div class="d-flex">
              <div style="font-weight: bold;">
                疵点明细：
              </div>
              <div v-if="row.inspectionDefectList.length">
                <div
                  v-for="(item, index) in row.inspectionDefectList"
                  :key="index"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
